(function () {
  var parseJsonAttribute = function (element, attribute) {
    var value = element.getAttribute(attribute);

    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      console.warn('[Custom Swiper] Invalid JSON in ' + attribute + ':', error);
      return null;
    }
  };

  var getSwiperOptions = function (element) {
    var options = parseJsonAttribute(element, 'data-swiper-options') || {};
    var navigation = element.querySelector('.swiper-button-next, .swiper-button-prev');
    var pagination = element.querySelector('.swiper-pagination');
    var config = {
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      a11y: {
        enabled: true,
      },
    };

    if (navigation) {
      config.navigation = {
        nextEl: element.querySelector('.swiper-button-next'),
        prevEl: element.querySelector('.swiper-button-prev'),
      };
    }

    if (pagination) {
      config.pagination = {
        el: pagination,
        clickable: true,
      };
    }

    Object.keys(options).forEach(function (key) {
      config[key] = options[key];
    });

    return config;
  };

  var initSwiper = function (element) {
    if (!element || !window.Swiper || element.swiper) {
      return element && element.swiper ? element.swiper : null;
    }

    return new window.Swiper(element, getSwiperOptions(element));
  };

  var initSwipers = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-swiper]:not(.swiper-initialized)').forEach(function (element) {
      initSwiper(element);
    });
  };

  var destroySwipers = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-swiper].swiper-initialized').forEach(function (element) {
      if (element.swiper) {
        element.swiper.destroy(true, true);
      }
    });
  };

  window.initSwipers = initSwipers;
  window.initSwiper = initSwiper;

  var bootstrap = function () {
    if (window.Swiper) {
      initSwipers();
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSwipers();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSwipers(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySwipers(event.target);
  });
})();
